<template>
    <section class="content-section  pt-50" style="padding-bottom: 0px; padding-top: 10px !important;">
        <div class="container">
            <div class="row">
                <div class="col-12 pd-13">
                    <div class="section-title mb-25" style="margin-bottom: 0px;">

                        <h2 style="padding-top: 10px !important; ">Movies</h2>
                        <div class="tabs-1 ">
                            <span class="tabmov" >
                                <a style=" padding: 0px; font-size: 16px;font-weight: 600;"  data-tab="orange"
                                    @click="tabsFromClasses($event, 'myClass')" :class="{ active: activeTab === 'orange' }"
                                    class="b-nav-tab myClass active">
                                    WHAT’S ON</a> </span>
                            <span class="pl-23">
                                <a style="padding: 0px; font-size: 16px;font-weight: 600;"  data-tab="green"
                                    @click="tabsFromClasses($event, 'myClass')" :class="{ active: activeTab === 'green' }"
                                    class="b-nav-tab myClass">WHAT’S COMING</a>
                            </span>
                            <div id="orange" class="b-tab myClass-div active pt-0" style=" margin-left: 10px;
margin-right: 10px;">
                                <div class="row" >
                                    <div class="col-4 col-lg-2 col-sm-4 pad-all5" v-for="(item, index) in movies" :key="index" >
                                        <div class="post
  "> <a 
      href="#"
      class="plybtntrail"
      :data-title="item.title"
      :data-video="item"
      @click="playVideo(item,'mv')">
                                                <div class="category-thumb">
                                                    <figure class="category-image bor8"> <img class="bor8"
                                                        :src=path+item.poster alt="Image">
                                                    </figure>
                                                    <div class="category-content pad-all10">

                                                        <ul class="tags  text-center">
                                                            <li class="mar0"> </li>
                                                        </ul>
                                                        <div class="details">{{ item.title }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="green" class="b-tab myClass-div pt-0" style="margin-left: 10px;
margin-right: 10px;">
                                <div class="row">
                                    <div  v-for="(item, index) in commingsoon" :key="index" class="col-4 col-lg-2 col-sm-4 pad-all5">
                                        <div class="  post
  ">
                                            <a href="#" class="plybtntrail" :data-title="item.title" :data-video="item" @click="playVideo(item,
                      'cmng')">
                                                <div class="category-thumb">
                                                    <figure class="category-image bor8"> <img class="bor8"
                                                        :src=path+item.poster  alt="Image"> </figure>
                                                    <div class="category-content pad-all10">

                                                        <ul class="tags text-center">
                                                            <li class="mar0"> </li>
                                                        </ul>

                                                        <div class="details">

                                                            {{ item.title }}</div>
                                                    </div>
                                                    <!-- end category-content -->
                                                </div>
                                            </a>
                                        </div>
                                        <!-- end category-thumb -->
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="row trailwrap hidewrp padlr" style="margin-left: 0px; padding: 0px; overflow: hidden scroll;
  height: 355px; width: 95%;
margin-right: 0px;" id="trailwrap">
<span class=" clsbtnmob" style="margin-top: 5px;float:right;z-index: 1000;margin-left: 90%;position: absolute;"
      @click="closebutton($event)"
      ><i class="fa fa-window-close" aria-hidden="true" style="color: white;
  font-size: 15px;"
></i>
</span>
                            <div class="col-12 pop">
                                <div>
                                    <div class="col-xs-12 col-sm-12 col-md-5 " style="float: left;">
                                        <div class="pophed" id="mvttl"></div>
                                        <div class="popcont">
                                            <span v-if="mvdetail.dur"><i class="fa fa-clock-o colye" style="padding-right: 5px;" aria-hidden="true"></i> 
                                                 <span class="popsubhe">  {{ timeConvert(mvdetail.dur) }}</span></span>
                                                <span><i class="fa fa-globe colye" style="padding-right: 5px;" aria-hidden="true"></i>
                        <span class="popsubhe" v-if="mvdetail.lang"> {{ getLang(Languages, mvdetail.lang) }} </span> </span> <span
                        class="popsrt">{{ mvdetail.cert }}</span>
                                        </div>
                                        <div class="pop-p" v-if="mvdetail.description">
                                            {{ mvdetail.description }}
                                        </div>
                                        <div class="pop-p pt-10 pb-8">
                                            <span v-if="mvdetail.dir"><b class="colye">
                                                    Director : </b> {{mvdetail.dir}}</span><br>
                                                    <span v-if="mvdetail.prod"><b class="colye">
                          Producer : </b> {{ mvdetail.prod }}</span><br>
                      <span v-if="mvdetail.cast"> <b class="colye">
                          Cast : </b> {{ mvdetail.cast }}
                          
                      </span>
                                        </div>
                                        <div class=" pb-15">
                                            <router-link class="play-btn popbtn" v-if="mvdetail.slug" :to="'moviedetails/'+mvdetail.slug" style="height: 39px;
line-height: 36px;">Book Tickets</router-link>
                                            <a style="width: 40px;
height: 40px;
line-height: 28px;" :href="mvdetail.trailer" data-vbtype="video"
                                                class="venobox pop-a "  data-autoplay="true" ><i
                                                    class="lni lni-play popicon" style="font-size: 14px;"></i></a>
                                        </div>
                                    </div>
                                    <div class="col-xs-12 col-sm-12 col-md-7 pop-send">
                                        <div>
                                            <img src="images/overlay-grey-shade2.png" alt="" class="pop-hovimg">
                                        </div>
                                        <div class='ResponsiveYTPlayer'>
                                            <div id="player"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import venobox from "venobox";
import axios from 'axios';
import { URL, UPLOADS } from '@/conf.js';
export default {

    data() {
        return {
            activeTab: 'orange',
      locid: 1,
      movies: [],
      commingsoon: [],
      mvdetail: [],
      isLoading: true,
      path: UPLOADS,
      YTPlayer : require('yt-player'),
      Languages: { "1": "Malayalam", '2': "Tamil", '3': "Hindi", '4': "English", '5': "Telugu", '6': "Kannada" },
        };
    },
    methods: {
        closebutton() {
            var trailwrapitems = document.getElementsByClassName('trailwrap');
            for (var trl of trailwrapitems) {
                trl.classList.add('hidewrp');
            }
            var postitems = document.getElementsByClassName('post');
            for (var pst of postitems) {
                pst.classList.remove('bgcol');
            }
            const player = new this.YTPlayer('#player');
      player.destroy();
        },
        tabsFromClasses(event, input_class) {

            const clickedTab = event.currentTarget;
            const clickedDataTabId = clickedTab.getAttribute('data-tab');
            this.$el.querySelectorAll('.trailwrap').forEach((element) => {
                element.classList.add('hidewrp');
            });
            this.$el.querySelectorAll('.bgcol').forEach((element) => {
                element.classList.remove('bgcol');
            });
            const tabsNavElements = this.$el.getElementsByClassName(input_class);
            for (let i = 0; i < tabsNavElements.length; i++) {
                if (tabsNavElements[i] === clickedTab) {
                    tabsNavElements[i].classList.add('active');
                } else {
                    tabsNavElements[i].classList.remove('active');
                }
            }
            const tabsDivElements = this.$el.getElementsByClassName(input_class + '-div');
            for (let i = 0; i < tabsDivElements.length; i++) {
                const id = tabsDivElements[i].getAttribute('id');
                if (id === clickedDataTabId) {
                    tabsDivElements[i].classList.add('active'); // Show the corresponding div
                } else {
                    tabsDivElements[i].classList.remove('active'); // Hide the corresponding div
                }
            }
        },
        playVideo(Item,type) {
            this.mvdetail=[];
    if(type=="mv"){
      axios.get(URL + "movie/" + Item.slug).then((response) => {
        this.mvdetail = response.data.result;
      }).then(() => {
        new venobox();

        const youtubeRegex = /(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?vi=|watch\?v=|watch\?feature=player_embedded&v=|watch\?v&v=|watch\?feature=player_embedded&v=|embed\?\S*?v=|embed\/\S*?v=))([\w-]{11})/;
        const match = this.mvdetail.trailer.match(youtubeRegex);
        
        const player = new this.YTPlayer('#player');
        player.destroy();
        if (player.destroyed == true) {
          const players = new this.YTPlayer('#player');
          players.load(match[1], true);
          // players.play();
          players.mute();
        }

      });
    }
    else{
      this.mvdetail=Item;
      const youtubeRegex = /(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?vi=|watch\?v=|watch\?feature=player_embedded&v=|watch\?v&v=|watch\?feature=player_embedded&v=|embed\?\S*?v=|embed\/\S*?v=))([\w-]{11})/;
        const match = this.mvdetail.trailer.match(youtubeRegex);
      const player = new this.YTPlayer('#player');
        player.destroy();
        if (player.destroyed == true) {
          const players = new this.YTPlayer('#player');
          players.load(match[1], true);
          // players.play();
          players.mute();
        }

    }
      event.preventDefault();
      this.$el.querySelector('#mvttl').textContent = Item.title;
      this.$el.querySelectorAll('.bgcol').forEach((element) => {
        element.classList.remove('bgcol');
      });
      const prnt = event.currentTarget.closest('.col-4'); 
      const tpos = prnt.offsetTop + prnt.offsetHeight;
      const trailwrap = document.getElementById('trailwrap');
      prnt.parentNode.insertBefore(trailwrap, prnt);
      trailwrap.style.position = 'absolute';
      trailwrap.style.zIndex = 100;
      trailwrap.style.top = tpos + 'px';
      trailwrap.style.boxShadow = 'rgba(0, 0, 0, 0.09) 0px 48px 100px 0px';
      trailwrap.style.marginLeft = '0px';
      trailwrap.style.marginRight = '3px';
      trailwrap.style.borderRadius = '10px';
      this.$el.querySelectorAll('.hidewrp').forEach((element) => {
        element.classList.remove('hidewrp');
      });
      prnt.querySelector('.post').classList.add('bgcol');
      

    },
    getMovies() {
      this.locid = 1
      if (this.locid) {
        axios.get(URL + "movies/" + this.locid).then((response) => {
          this.movies = response.data.result;
        }).then(() => {

          this.isLoading = false;
        })
      }
    },
    getCommingsoon() {
      this.locid = 1
      if (this.locid) {
        axios.get(URL + "commingSoon").then((response) => {
          this.commingsoon = response.data.result;
          console.log(response.data.result)
        }).then(() => {
        })
      }
    },

    },
    computed: {

getLang: () => {
  return (langs, key) => {
    return langs[key]
  }

},
timeConvert: () => {
  return (num) => {
    var hours = (num / 60);
var rhours = Math.floor(hours);
var minutes = (hours - rhours) * 60;
var rminutes = Math.round(minutes);
return rhours + "h" + rminutes + "m";
  }

},


},
mounted() {
this.getMovies();
this.getCommingsoon();
}

};
</script>
<style>
@import "../../../node_modules/venobox";
</style>